import React from 'react';
import PropTypes from 'prop-types';

const TitleRow = ({dateTime, name, location }) => (
    <div style={{
        width: '100%',
        padding: '4px 0'
    }}>
        <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            marginBottom: '4px'
        }}>

            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                marginBottom: '4px'
            }}>
                <div style={{ flex: 0.2, textAlign: 'left', fontWeight: 'bold', fontSize: '0.8rem' }}>
                    නමඃ ශ්‍රී ඝණාය!
                </div>
                <div style={{ flex: 0.6, textAlign: 'center', fontWeight: 'bold', fontSize: '1rem' }}>
                    ජන්ම පත්‍රය
                </div>
                <div style={{ flex: 0.2, textAlign: 'left', fontWeight: 'bold', fontSize: '0.8rem' }}>
                </div>
            </div>
            
        </div>
        <div style={{
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            marginTop: '4px'
        }}>
            <div style={{ flex: '0 0 20%', fontWeight: 'bold', fontSize: '0.8rem', textAlign: 'left', paddingRight: '8px' }}>
                නම:
            </div>
            <div style={{ flex: '0 0 80%' }}>
                <input
                    type="text"
                    style={{ width: '100%', fontSize: '0.8rem', padding: '2px 4px' }}
                    defaultValue={name}
                    name="namaand"
                />
            </div>
        </div><div style={{
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            marginTop: '4px'
        }}>
            <div style={{ flex: '0 0 20%', fontWeight: 'bold', fontSize: '0.8rem', textAlign: 'left', paddingRight: '8px' }}>
                වේලාව:
            </div>
            <div style={{ flex: '0 0 80%', fontSize: '0.8rem' }}>
                <span>{dateTime}</span>
            </div>
        </div>
        <div style={{
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            marginTop: '4px'
        }}>
            <div style={{ flex: '0 0 20%', fontWeight: 'bold', fontSize: '0.8rem', textAlign: 'left', paddingRight: '8px' }}>
                ස්ථානය:
            </div>
            <div style={{ flex: '0 0 80%', fontSize: '0.8rem' }}>
                <span>{location}</span>
            </div>
        </div>
        
    </div>
);

TitleRow.propTypes = {
    dateTime: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    location: PropTypes.string.isRequired,
};

export default TitleRow;